import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

import SelectField from '../../components/form/SelectField';
import { Context } from '../../context/DataContext';

const CheckOrderInfoAgainPage = () => {
  const navigate = useNavigate();
  const { state } = React.useContext(Context);
  const { customerInfo, paymentList } = state;
  const [paymentMethod, setPaymentMethod] = React.useState(customerInfo.payType || '');
  const [periodType, setPeriodType] = React.useState(customerInfo.periodType || '');
  const [warrantyMonth, setWarrantyMonth] = React.useState(
    customerInfo.warrantyMonth ? String(customerInfo.warrantyMonth) : ''
  );

  const paymentInfo = paymentMethod
    ? paymentList.find(
        ({ PaymentType, PeriodType, WarrantyMonth }) =>
          PaymentType === paymentMethod &&
          PeriodType === periodType &&
          String(WarrantyMonth) === warrantyMonth
      )
    : {};

  return (
    <Box>
      <Typography variant="h4" sx={{ my: 2 }}>
        要保資料確認
      </Typography>
      <Box sx={{ px: 2, textAlign: 'left' }}>
        <Typography variant="h6" sx={{ my: 2 }}>
          機型：{customerInfo.market_n}
        </Typography>
        <Typography variant="h6" sx={{ my: 2 }}>
          IMEI：{customerInfo.imei}
        </Typography>
        <Typography variant="h6" sx={{ my: 2 }}>
          服務名稱：{customerInfo.serviceName}
        </Typography>
        <SelectField
          fullWidth
          id="payment-method"
          label="付款方式"
          placeholder="請選擇..."
          value={paymentMethod ? `${paymentMethod}+${periodType}+${warrantyMonth}` : ''}
          onChange={(e) => {
            const [paymentMethod, periodType, warrantyMonth] = e.target.value.split('+');
            setPaymentMethod(paymentMethod);
            setPeriodType(periodType);
            setWarrantyMonth(warrantyMonth);
          }}
          options={paymentList.map(
            ({ PaymentType, PaymentTypeName, PeriodType, WarrantyMonth }) => ({
              id: `${PaymentType}+${PeriodType}+${WarrantyMonth}`,
              value: `${PaymentType}+${PeriodType}+${WarrantyMonth}`,
              text: PaymentTypeName,
            })
          )}
        />
        {paymentMethod ? (
          <>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`保險費：${paymentInfo.InsurancePrice}元`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`置換費用：${paymentInfo.SwapPrice}元`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`生效日期：${paymentInfo.InsuranceStartDate}`}
            </Typography>
            <Typography variant="h6" sx={{ my: 2 }}>
              {`到期日期：${paymentInfo.InsuranceEndDate}`}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
              }}
            >
              <Button
                color="secondary"
                variant="contained"
                sx={{ width: 128 }}
                onClick={() => {
                  navigate('/dashboard');
                }}
              >
                不同意
              </Button>
              <LoadingButton
                variant="contained"
                sx={{ width: 128 }}
                onClick={() => {
                  navigate('/burglary-insur/check-pdf-again');
                }}
              >
                確認要保書
              </LoadingButton>
            </Box>
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default CheckOrderInfoAgainPage;
